<template>
  <div :class="extraClass">
    <img :src="getImage(product)" alt="" class="w-[1.875rem] h-[1.875rem]" />
  </div>
</template>

<script>
// assets

import blueOil from "@/assets/svg/blue-oil.svg";
import greenOil from "@/assets/svg/green-oil.svg";
import yellowOil from "@/assets/svg/yellow-oil.svg";
import purpleOil from "@/assets/svg/purple-oil.svg";

//utils
import { lowerCase } from "@/core/helpers/utility";

export default {
  name: "ProductOilAvatar",
  props: ["extraClass", "product"],
  data() {
    return {
      lowerCase,
    };
  },
  methods: {
    getImage(name) {
      switch (lowerCase(name)) {
        case "pms":
          return yellowOil;
        case "ago":
          return greenOil;
        case "dpk":
          return blueOil;
        case "lpg":
          return purpleOil;
        default:
          return yellowOil;
      }
    },
  },
};
</script>

<style></style>
